import React, { Fragment } from 'react';
import { Column, Section, Container, Card, Navbar } from "rbx";
import LoginForm from "../../components/auth/login_form";
import Header from "../../components/shareds/header";
import logo from '../../assets/images/logo.png';
// import bannerWebp from '../../assets/images/bannerWebp.webp';
import { InsProgressBar } from 'react-ins-progress-bar';
import Footer from '../../components/shareds/footer';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faThumbsUp, faArrowAltCircleLeft, faSearch, faEraser } from '@fortawesome/free-solid-svg-icons';

function LoginScreen() {
    return (
        <Fragment>
            <InsProgressBar
                height="3px"
                delay={600}
                position="top"
                colors={`
                #dc3545 15%,
                #dc3545 15%,
                #dc3545 12%,
                #dc3545 32%,
                #dc3545 35%,
                #dc3545 55%,
                #dc3545 59%,
                #dc3545 63%,
                #dc3545 92%`
                }
            />

            <Header />
            <Section size="medium" className="login">
                <Container>
                    <Column.Group centered>
                        <Column size={5}>
                            <Card className="card-login">
                                <Card.Content>
                                    <img className="logo" src={logo} alt="Unipar." />
                                    <div className="msg">Informe os dados e clique em <strong>Realizar Prova Online.</strong></div>
                                    <LoginForm />
                                </Card.Content>
                            </Card>
                        </Column>
                    </Column.Group>
                </Container>
            </Section>
            <Footer />
        </Fragment>
    )
}

export default LoginScreen;